import type { ResourcesConfig } from 'aws-amplify';

import exportsJson from './aws-exports.json';

export const apiEndpoint = import.meta.env.DEV ? '/api' : exportsJson.apiEndpoint;

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: exportsJson.cognitoUserPoolId,
      userPoolClientId: exportsJson.cognitoUserPoolClientId,
    },
  },
};

export default awsConfig;
